// desktop.guard.ts
import { Injectable, inject } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Injectable({
    providedIn: 'root',
})
export class DesktopGuard implements CanActivate {
    #breakpointObserver = inject(BreakpointObserver);

    canActivate(): Observable<boolean> {
        return this.#breakpointObserver.observe([Breakpoints.Handset]).pipe(
            map((result) => !result.matches),
        );
    }
}
